<template>
  <div class="page-container">
    <div class="contact-container">
      <div class="contact-info">
        <h2>{{ $t('contactUs.title') }}</h2>
        <div class="contact-method">
          <img src="@/assets/imgs/home/youxiang.png"/>
          <p>{{ $t('contactUs.contactEmailMethod') }}<br>ubcard@ubcard.io</p>
        </div>
        <div class="contact-method">
          <img src="@/assets/imgs/home/meiti.png"/>
          <p>{{ $t('contactUs.contactMediumMethod') }}</p>
        </div>
      </div>
      <div class="contact-form">
        <h3>{{ $t('contactUs.contactForm.title') }}</h3>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="name">{{ $t('contactUs.contactForm.name') }}</label>
            <input type="text" id="name" v-model="formData.name" required class="input-bg"/>
          </div>
          <div class="form-group">
            <label for="email">{{ $t('contactUs.contactForm.email') }}</label>
            <input type="email" id="email" v-model="formData.email" required />
          </div>
          <div class="form-group">
            <label for="message">{{ $t('contactUs.contactForm.message') }}</label>
            <textarea id="message" v-model="formData.message" required></textarea>
          </div>
          <button type="submit">{{ $t('contactUs.contactForm.submit') }}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    handleSubmit() {
      this.$message.success('submit success');
      this.formData = { name: '', email: '', message: '' };
    }
  }
};
</script>

<style scoped lang="less">
.page-container {
  padding: 50px;
}
.contact-container {
  display: flex;
  background-size: cover;
  background-image: url('~@/assets/imgs/home/cubg.png');
  background-repeat: no-repeat;
  background-position: center;
  padding: 50px 70px;
  border-radius: 10px;
  color: white;
  .contact-info {
    flex: 2;
    padding: 20px;

    h2 {
      font-size: 3em;
      margin-bottom: 20px;
    }

    .contact-method {
      margin-bottom: 20px;
      img {
        width: 30px;
      }
      p {
        font-size: 16px;
      }
    }
  }

  .contact-form {
    flex: 1;
    background: white;
    padding: 20px;
    border-radius: 10px;
    color: black;

    h3 {
      font-size: 1.5em;
      margin-bottom: 20px;
    }

    .form-group {
      margin-bottom: 15px;

      label {
        display: block;
        margin-bottom: 5px;
      }

      input, textarea {
        width: 100%;
        padding: 8px;
        box-sizing: border-box;
        background-color: #f0f0f0;
        border: none;
      }

      textarea {
        height: 100px;
      }
    }

    button {
      padding: 10px 20px;
      background-color: #1e3799;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      width: 100%;
    }
  }
}
</style>
